module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "pl10px pr10px",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车主ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerInfo.id),
      expression: "ownerInfo.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.ownerInfo.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车主类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerInfo.customerType),
      expression: "ownerInfo.customerType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ownerInfo, "customerType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.customerTypes), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("车主名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.ownerName),
      expression: "ownerInfo.ownerName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.ownerInfo.ownerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "ownerName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("证件类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerInfo.certificatesType),
      expression: "ownerInfo.certificatesType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ownerInfo, "certificatesType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.certificatesTypes), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("证件号码")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.identifyNo),
      expression: "ownerInfo.identifyNo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.ownerInfo.identifyNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "identifyNo", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系电话1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.phone),
      expression: "ownerInfo.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.ownerInfo.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系电话2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.phone2),
      expression: "ownerInfo.phone2",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.ownerInfo.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "phone2", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("电子邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.email),
      expression: "ownerInfo.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.ownerInfo.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "email", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.ownerInfo.email.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.ownerInfo.email.email && _vm.$v.ownerInfo.email.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("您的邮箱格式不正确")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("QQ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.bindQq),
      expression: "ownerInfo.bindQq",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.ownerInfo.bindQq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "bindQq", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerInfo.address),
      expression: "ownerInfo.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.ownerInfo.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "address", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系人1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.linkMan1),
      expression: "ownerInfo.linkMan1",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.ownerInfo.linkMan1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "linkMan1", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.linkPhone1),
      expression: "ownerInfo.linkPhone1",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.ownerInfo.linkPhone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "linkPhone1", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("与车主关系")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.relationMan1),
      expression: "ownerInfo.relationMan1",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.ownerInfo.relationMan1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "relationMan1", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系人2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.linkMan2),
      expression: "ownerInfo.linkMan2",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.ownerInfo.linkMan2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "linkMan2", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.linkPhone2),
      expression: "ownerInfo.linkPhone2",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.ownerInfo.linkPhone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "linkPhone2", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("与车主关系")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ownerInfo.relationMan2),
      expression: "ownerInfo.relationMan2",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.ownerInfo.relationMan2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "relationMan2", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_center"
  }, [_vm._v("工作备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerInfo.memo),
      expression: "ownerInfo.memo"
    }],
    staticClass: "col-sm-11",
    attrs: {
      "rows": "6",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.ownerInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerInfo, "memo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group t_center"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.permission.indexOf('fileCarList_vehicleOwnerSave') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.enableSubmit
    },
    on: {
      "click": _vm.ensureSave
    }
  }, [_vm._v("保存车主信息")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.permission.indexOf('fileCarList_vehicleOwnerResetPassword') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("重置车主端密码")]) : _vm._e()])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModal
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "resertModalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeRestorModal
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.messageStr) + "\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeRestorModal
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmResetting
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e876c3","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didicarfile/detail/DetailOwner.vue
// module id = 1547
// module chunks = 0